import React from 'react';
import styles from './DeletedMessageTemplateBubble.scss';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import { Text } from 'wix-style-react';
var DeletedMessageTemplateBubble = function (_a) {
    var _b, _c;
    var message = _a.message;
    var defaultText = 'This message was deleted.';
    return (React.createElement("div", { "data-hook": "deleted-message-template-bubble-wrapper", className: classNames(styles.wrapper) },
        React.createElement(Text, { skin: "disabled", dataHook: "deleted-message-text" }, ((_b = message === null || message === void 0 ? void 0 : message.templateData) === null || _b === void 0 ? void 0 : _b.text) ? (_c = message === null || message === void 0 ? void 0 : message.templateData) === null || _c === void 0 ? void 0 : _c.text : defaultText)));
};
export default withTranslation()(DeletedMessageTemplateBubble);
//# sourceMappingURL=DeletedMessageTemplateBubble.js.map